import React from 'react';
import brandConfig from '../../config/brandConfig';
import { ExternalLink, Sparkles } from 'lucide-react';

const ProjectViewerSection = () => {
  const projectDemoUrl = brandConfig.projectDemoUrl;

  return (
    <div className="py-24 lg:py-32 bg-gray-50 dark:bg-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orange-100 dark:bg-orange-900/30 border border-orange-200 dark:border-orange-800 mb-6">
            <Sparkles className="w-4 h-4" style={{ color: brandConfig.primaryColor }} />
            <span className="text-sm font-bold" style={{ color: brandConfig.primaryColor }}>Demo en Vivo</span>
          </div>
          <h2 className="text-4xl lg:text-6xl font-extrabold text-gray-900 dark:text-white mb-6 tracking-tight">
            Visor de Proyecto
            <span className="block font-display italic mt-2" style={{ color: brandConfig.primaryColor }}>en Vivo</span>
          </h2>
          <p className="text-lg text-gray-500 dark:text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Explora un proyecto real con nuestro visor interactivo. Navega por el mapa,
            consulta lotes disponibles y visualiza toda la informacion en tiempo real.
          </p>
        </div>

        {/* Embedded Viewer */}
        <div className="bg-white dark:bg-gray-900 rounded-3xl shadow-2xl shadow-gray-200/50 dark:shadow-none border border-gray-100 dark:border-gray-800 overflow-hidden">
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              src={projectDemoUrl}
              title="Visor de Proyecto - LotesPro"
              className="absolute inset-0 w-full h-full"
              allow="geolocation; fullscreen"
              loading="lazy"
            />
          </div>
        </div>

        {/* Link to full viewer */}
        <div className="text-center mt-10">
          <a
            href={projectDemoUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 text-white px-8 py-4 rounded-2xl font-bold text-lg transition-all duration-300 shadow-xl shadow-orange-500/20 hover:shadow-orange-500/30 hover:scale-[1.03]"
            style={{ background: brandConfig.getPrimaryGradient() }}
          >
            <ExternalLink className="w-5 h-5" />
            Abrir Visor Completo
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProjectViewerSection;
